// extracted by mini-css-extract-plugin
export default {"primaryColor":"#F23B4D","whiteColor":"#FFFFFF","container":"Refresh_container__xrZ4C","circle":"Refresh_circle__ruPJ+"};